export default (filterFormId) => ({
  filterFormId: filterFormId,

  getFilterData() {
    // Writing this proxy seemed more straightforward than rewriting thoughtsFilter to a singleton so I could use the same thing twice
    return Alpine.$data(document.getElementById(this.filterFormId));
  },

  updateKeywords(event) {
    this.getFilterData().updateKeywords(event.target.value)
  },

  submitForm() {
    this.getFilterData().submitForm();
  }
});
